import { z } from 'zod';
import { ON_OFF } from './helpers/enums.ts';

export const statsMessageMetricsSchema = z.enum([...ON_OFF, '']);
